import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../utils/OtherUtils';
import UIWrapper from '../components/UIWrapper';
import ProductFilter from '../components/ProductFilter';
import NavigationTracker from '../components/NavigationTracker';
import ProductComponent from '../components/ProductComponent';
import { useTestContext } from '../context/TestContext';
import { useOrderProcessingContext } from '../context/OrderProcessingContext';
import { useAuthContext } from '../context/AuthContext';


const brancNameFilter = [
	"Redcliffe labs",
	"Agilus Diagnostics",
	"Pathkind Labs",
	"Metropolis Healthcare",
];

const ProductDetails = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

    const {
      popularProducts,
      fetchPopularProducts
    } = useTestContext();

    const { order, addProductToCart, removeProductById } = useOrderProcessingContext();

     const isInCart = order?.orderData?.some((entry) =>
    entry.items.some((item) => item?.product?._id === product?._id)
  );

    useEffect(()=> {
      	fetchPopularProducts();
    },[])

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/products/products/${productId}`);
        // console.log("product---->",res.data.data)
        setProduct(res.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  const [isReadMore,setIsReadMore] = useState(false)
  const [name,setName] = useState('');
  const [number,setNumber] = useState('');
  const [isCallbackSent,setIsCallbackSent] = useState(false);
  const [deviceOs,setDeviceOS] = useState("");




  const handleNameChange = (e) => {
    setName(e.target.value);
  }

  const handleNumberChange = (e) => {
    setNumber(e.target.value);
    // setNumber(e.target.value);
    // if(e.target.value.length<=10){
    //   if(['e', 'E', '+', '-', '.'].includes(e.key)){
    //     e.preventDefault();
    //   }
    // }  }
  }

  const handleGetCallbackClick = async() => {
    // console.log(name,number)
    const tempName = name;
		const tempNumber = number;
    try {
			await axios.post(`${baseUrl}/api/callbackRequest/add-callbackRequest`, {
				name,
				number,
			});
			setName("");
			setNumber("");
      setIsCallbackSent(true);
		} catch (error) {
			setName(tempName);
			setNumber(tempNumber);
		}
  }

  
  const detectDeviceOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/android/.test(userAgent)) {
      setDeviceOS("android");
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setDeviceOS("ios");
    } else {
      setDeviceOS("unknown");
    }
  };

  useEffect(()=>{
    detectDeviceOS()
  },[])


  

  if (loading) return <div></div>;
  if (error) return <div></div>;

  return (
    <UIWrapper searchVisible={false}>
      <ProductFilter />
      <div className="w-full h-fit px-[3%] py-2 lg:px-[2%] lg:py-[2%]">
      <NavigationTracker endpoint={product.productTitle} />
      </div>
      <div className='grid grid-cols-1 lg:grid-cols-[6fr_2fr] gap-8 px-[3%] py-2 lg:px-[10%] lg:py-[2%]'>
        <div>
            <div className='w-full h-[400px] lg:h-[272px] rounded-[32px] bg-[#d6e6ff] pl-[4%] pt-[2%] relative'>
            <div className="flex items-center gap-4 mb-6 mt-[2%] lg:mt-0">
              <img src={product.brandImg} alt={product.brandName} className="w-16 h-16 object-contain" />
              <div>
                <h1 className={`${product.productTitle.length > 50 ? 'w-full lg:w-[60%]': 'w-[100%]'} relative font-semibold z-10 text-[16px] lg:text-[20px]`}>{(deviceOs === "android" || deviceOs === "ios") ? product.productTitle.slice(0,50) : product.productTitle}</h1>
                <p className="relative text-[#57636C] z-10 text-[14px]">by {product.brandName}</p>
              </div>
            </div>
              {(deviceOs === "android" || deviceOs === "ios") ? (
                  <div className="flex flex-col lg:flex-row  lg:items-center pt-[4%] mt-[24%] lg:mt-0 h-[300px] lg:h-[100px]  lg:space-y-0 lg:space-x-[12%]">
                {product.reportIn && (
                  <div className='flex lg:justify-center z-10 items-center space-x-[5%] mb-[10px] w-[250px] '>
                  <img src="/assets/done-icon.svg" alt="done-icon" />
                  <div className='text-[14px] font-medium text-[#22282F]'>Report in {product.reportIn === "Same day reporting" ? product.reportIn.slice(0,8) : product.reportIn}</div>
                </div>
                )}
                {(product.parameterCovered || product.noOfParameters) && (
                  <div className='flex lg:justify-center z-10 items-center space-x-[5%] mb-[10%] w-[200px]'>
                  <img src="/assets/parameterIcon.png" alt="done-icon" className='w-[24px] h-[27.7px]'/>
                  <div className='text-[14px] font-medium text-[#22282F]'>{product.parameterCovered ? product.parameterCovered : product.noOfParameters} paramters covered</div>
                </div>
                )}
                <div className='flex flex-col h-[100px] z-10 relative'>
                  <div className='w-[160px] h-[77px] z-10 rounded-t-[20px] bg-white flex flex-col pt-[2%] lg:pt-[5%] items-center'>
                  <div className='font-semibold z-10 text-[20px]'>{product.currency} {product.sellingPrice}</div>
                </div>
                {isInCart ? (
                  <div className='flex justify-center z-10 items-center h-[56px] text-white w-[160px] lg:w-full bg-accentColor rounded-[40px] absolute bottom-0 left-0 cursor-pointer' onClick={()=>{removeProductById(product?._id)}}>
                    Remove
                </div>
                ):(
                  <div className='flex justify-center z-10 items-center h-[56px] text-white w-[160px] lg:w-full bg-[#0047AF] rounded-[40px] absolute bottom-0 left-0 cursor-pointer' onClick={()=>{addProductToCart(product)}}>
                    Add to Cart
                </div>
                )}
                </div>
              </div>
              ):(
                  <div className="flex flex-col lg:flex-row  lg:items-center pt-[4%] mt-[24%] lg:mt-0 h-[300px] lg:h-[100px] space-y-[5%] lg:space-y-0 lg:space-x-[12%]">
                <div className='flex flex-col h-[100px] z-10 relative'>
                  <div className='w-[160px] h-[77px] z-10 rounded-t-[20px] bg-white flex flex-col pt-[5%] items-center'>
                  <div className='font-semibold z-10 text-[20px]'>{product.currency} {product.sellingPrice}</div>
                </div>
                {isInCart ? (
                  <div className='flex justify-center z-10 items-center h-[56px] text-white w-[160px] lg:w-full bg-accentColor rounded-[40px] absolute bottom-0 left-0 cursor-pointer' onClick={()=>{removeProductById(product?._id)}}>
                    Remove
                </div>
                ):(
                  <div className='flex justify-center z-10 items-center h-[56px] text-white w-[160px] lg:w-full bg-[#0047AF] rounded-[40px] absolute bottom-0 left-0 cursor-pointer' onClick={()=>{addProductToCart(product)}}>
                    Add to Cart
                </div>
                )}
                </div>
                {product.reportIn && (
                  <div className='flex lg:justify-center z-10 items-center space-x-[5%] w-[250px] '>
                  <img src="/assets/done-icon.svg" alt="done-icon" />
                  <div className='text-[14px] font-medium text-[#22282F]'>Report in {product.reportIn === "Same day reporting" ? product.reportIn.slice(0,8) : product.reportIn}</div>
                </div>
                )}
                {(product.parameterCovered || product.noOfParameters) && (
                  <div className='flex lg:justify-center z-10 items-center space-x-[5%] w-[200px]'>
                  <img src="/assets/parameterIcon.png" alt="done-icon" className='w-[24px] h-[27.7px]'/>
                  <div className='text-[14px] font-medium text-[#22282F]'>{product.parameterCovered ? product.parameterCovered : product.noOfParameters} paramters covered</div>
                </div>
                )}
              </div>
              )}
              <div className='absolute bottom-0 right-0'>
                <div className='bg-gradient-to-r from-[#D6E1F2] to-[#B9C8DC] w-[170px] h-[28px] text-[#57636C] text-[14px] font-medium rounded-br-[40px] flex justify-end pr-[10%] items-center'>
                  {product.productType === 'test' || product.productType === 'Pathology Test' ? 'Pathology Test' : product.productType}
                </div>
              </div>
                {product.brandName === "Dr Lal PathLabs" ? (
                   <img src="/assets/drlal-discount-image.png" alt="Dr lal Discount Image" className='w-[200px] h-[79px] lg:w-[219.83px] lg:h-[89px] z-10 absolute top-[23%] right-[20%] lg:top-[5%] lg:right-[13%]'/>
                ):(
                   <img src="/assets/discountImage.png" alt="Discount Image" className='w-[200px] h-[79px] lg:w-[219.83px] lg:h-[89px] z-10 absolute top-[23%] right-[20%] lg:top-[5%] lg:right-[13%]'/>
                )}
                {/* <img
                  src="/assets/cardShadeImage.png"
                  alt="Discount Image"
                  className="absolute top-0 bottom-0 z-2 h-full right-[4%] opacity-50"
                /> */}
            </div>
            {/* <div className='w-full h-fit lg:h-[98px] mt-[5%] lg:mt-[3%] px-[4%] space-y-[3%] pt-[5%] pb-[5%] lg:pt-0 lg:pb-0 lg:space-y-0 flex flex-col lg:flex-row lg:justify-between lg:items-center border border-[#00000014] rounded-[24px] bg-gradient-to-r from-[#F5F5F5] to-[#EEEEEE]'>
              {product.fastingRequired && (
                <div className='flex flex-col'>
                <div className='text-[15px] text-[#22282F]'>Fasting Required</div>
                <div className='text-[15px] text-[#22282F] font-semibold'>{product.fastingRequired}</div>
                {console.log("fasting", product.fastingRequired)}
              </div>
              )}
              {(product.recommendedGender || (product.recommendedFor && product.recommendedFor.length > 0))  && (
                <div>
                <div className='text-[15px] text-[#22282F]'>Test Recommended For</div>
                <div className='text-[15px] text-[#22282F] font-semibold'>{product.recommendedGender ? product.recommendedGender == "both" ? "For Everyone" : product.recommendedGender: product.recommendedFor}</div>
              {console.log("gender", product.recommendedGender)}
              </div>
              )}
              <div>
                <div className='text-[15px] text-[#22282F]'>Recommended For Age</div>
                <div className='text-[15px] text-[#22282F] font-semibold'>{product.recommendedAge?product.recommendedAge:'5 - 99 Years'}</div>
              </div>
            </div> */}


     <div className="w-full h-fit lg:h-[98px] mt-[5%] lg:mt-[3%] px-[4%] space-y-[3%] pt-[5%] pb-[5%] lg:pt-0 lg:pb-0 lg:space-y-0 flex flex-col lg:flex-row lg:justify-between lg:items-center border border-[#00000014] rounded-[24px] bg-gradient-to-r from-[#F5F5F5] to-[#EEEEEE]">

  {/* ================= RECOMMENDED SECTION ================= */}

  {(product?.viewDetail?.recommendedGender ||
    product?.viewDetail?.recommendedFor ||
    product?.viewDetail?.reportIn) ? (

    /*  SHOW BE DATA */
    <>
      <div className="flex flex-col">
        <div className="text-[15px] text-[#22282F]">Test recommended for</div>
        <div className="text-[15px] text-[#22282F] font-semibold">
          {product.viewDetail.recommendedGender
            ? product.viewDetail.recommendedGender === "both"
              ? "For Everyone"
              : product.viewDetail.recommendedGender
            : product.viewDetail.recommendedFor}
        </div>
      </div>

      <div className="flex flex-col">
        <div className="text-[15px] text-[#22282F]">Report in</div>
        <div className="text-[15px] text-[#22282F] font-semibold">
          {product.viewDetail.reportIn}
        </div>
      </div>
    </>

  ) : (

    /*  SHOW HARDCODED ONLY WHEN BE DATA NOT FOUND */
    <>
      {/* <div className="flex flex-col">
        <div className="text-[15px] text-[#22282F]">Test for gender</div>
        <div className="text-[15px] text-[#22282F] font-semibold">
          For Everyone
        </div>
      </div> */}

      <div className="flex flex-col">
        <div className="text-[15px] text-[#22282F]">Recommended For Age</div>
        <div className="text-[15px] text-[#22282F] font-semibold">
          5 - 99 Years
        </div>
      </div>
    </>
  )}

</div>


            {(product.noOfParameters || product.parameterCovered) && (
              <div className='w-full h-fit mt-[5%] lg:mt-[3%] px-[4%] pb-[2%] pt-[2%]  border border-[#00000014] rounded-[24px] bg-gradient-to-r from-[#F5F5F5] to-[#EEEEEE]'>
             <div className='text-[#000000] text-[16px] font-medium'>Parameter Included: {product.parameterCovered ? product.parameterCovered : product.noOfParameters}</div>
             {product.parametersName && product.parametersName.length != 0 && (
              <div>
                <div className='grid grid-cols-2 w-full bg-[#E5E5E5] rounded-[12px] h-[48px] px-[2%] items-center mt-[2%]'>
                <div>Profile/Parameter</div>
                <div>No. of Parameters</div>
              </div>
                {product.parametersName.map((parameter,index)=>(
                  <div className={`grid grid-cols-2 w-full px-[2%] items-center ${index === product.parametersName.length - 1 ? '' : 'border-b'} pt-[1%] pb-[1%]`}>
                  <div>
                    {parameter}:
                  </div>
                  <div className='pl-[5%]'>1</div>
                  </div>
                ))}
              </div>
             )}
            </div>
            )}
            {product.alsoKnownAs && (
              <div>
                <div className='text-[#000000] font-medium text-[16px] mt-[5%] lg:mt-[3%]'>
                  Also Known As:
                </div>
                <div>

                </div>
              </div>
            )}
            {product.productDescription &&  (
              <div className='mt-[3%]'>
                <div className='text-[16px] text-[#57636C]'>
                {isReadMore ? product.productDescription : (deviceOs === "android" || deviceOs === "ios") ? product.productDescription.slice(0,140) : product.productDescription.slice(0,250)}
                </div>
                <div className='text-[14px] underline text-[#0047AF] cursor-pointer' onClick={()=>setIsReadMore(!isReadMore)}>{isReadMore ? 'Read Less' : 'Read More'}</div>
              </div>
            )}
        </div>
        <div>
          <div className='flex flex-col justify-center px-[5%] space-y-[12%] items-center w-full lg:w-[300px] h-[312px] rounded-[32px] shadow-[0_0_5px_rgba(0,0,0,0.5)]'>
            <div className='text-[16px] '>Talk to our Health Advisor</div>
            <div className='w-full flex flex-col space-y-[5%]'>
              <input className='w-full h-[48px] rounded-[16px] border-2 border-[#212A3940] p-2 outline-none' placeholder='Full Name' onChange={handleNameChange}/>
              <div className='w-full h-[48px] flex border-2 border-[#212A3940] rounded-[16px] items-center'>
                <div className='border-r-2 h-full flex items-center px-2 text-[13px] text-[#57636C]'>+91</div>
                <input className='w-full h-full p-2 rounded-[16px] outline-none' 
                placeholder='Contact Number' 
                type='number' 
                onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handleNumberChange(e);
                }
              }}
              max={9999999999}
                onKeyDown={(e)=>{
                  if(['e', 'E', '+', '-', '.'].includes(e.key)){
                    e.preventDefault();
                  }
                }}
                // onChange={handleNumberChange}
                />
              </div>
            </div>
            {isCallbackSent ? (
              <div className='w-full h-[56px] text-[13px]  font-semibold flex justify-center items-center text-[#0047AF]'>
                Our team will reach out to you shortly
            </div>
            ):(
              <div className='w-full h-[56px] border-2 rounded-[40px] font-semibold flex justify-center items-center border-[#0047AF] text-[#0047AF] cursor-pointer' onClick={handleGetCallbackClick}>
              Get A Call Back
            </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <ProductComponent
        title={`More by ${product.brandName}`}
        filter={brancNameFilter}
        selectedOption={product.brandName}
        showSingleBrand= {true}
        products={popularProducts}
      />
      </div>
       <div>
        <ProductComponent
        title='Recommended Tests/Packages'
        filter={brancNameFilter}
        products={popularProducts}
      />
      </div>
    </UIWrapper>
  );
};

export default ProductDetails;
